import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  Grid,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";

const styles = (theme) => ({
  dialog: {
    minWidth: 600,
  },
  form: {
    width: "100%",
  },
  field: {
    marginBottom: 16,
  },
  checkboxGroup: {
    marginTop: 16,
  },
});

class NotificationModal extends Component {
  state = {
    title: "",
    description: "",
    messageInSpanish: "",
    messageInEnglish: "",
    sendInApp: true,
    sendPush: true,
    sendEmail: true,
  };

  handleChange = (event) => {
    const { name, value, checked } = event.target;
    this.setState({
      [name]: event.target.type === "checkbox" ? checked : value,
    });
  };

  handleSubmit = () => {
    const {
      title,
      description,
      messageInSpanish,
      messageInEnglish,
      sendInApp,
      sendPush,
      sendEmail,
    } = this.state;

    const { onSubmit, selectedUserIds, selectedConsumerIds } = this.props;

    const input = {
      title,
      description,
      messageInSpanish,
      messageInEnglish,
      userIds: selectedUserIds,
      consumerIds: selectedConsumerIds,
      sendInApp,
      sendPush,
      sendEmail,
    };

    onSubmit(input);
  };

  render() {
    const { classes, open, onClose, selectedUserIds, selectedConsumerIds } = this.props;
    const {
      title,
      description,
      messageInSpanish,
      messageInEnglish,
      sendInApp,
      sendPush,
      sendEmail,
    } = this.state;

    const totalSelected = (selectedUserIds && selectedUserIds.length ? selectedUserIds.length : 0) + (selectedConsumerIds && selectedConsumerIds.length ? selectedConsumerIds.length : 0);

    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        className={classes.dialog}
      >
        <DialogTitle>
          Enviar Notificaciones ({totalSelected} usuarios seleccionados)
        </DialogTitle>
        <DialogContent>
          <ValidatorForm
            ref="form"
            onSubmit={this.handleSubmit}
            className={classes.form}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextValidator
                  name="title"
                  label="Título *"
                  value={title}
                  onChange={this.handleChange}
                  validators={["required"]}
                  errorMessages={["El título es requerido"]}
                  fullWidth
                  className={classes.field}
                />
              </Grid>
              <Grid item xs={12}>
                <TextValidator
                  name="description"
                  label="Descripción *"
                  value={description}
                  onChange={this.handleChange}
                  validators={["required"]}
                  errorMessages={["La descripción es requerida"]}
                  fullWidth
                  multiline
                  rows={2}
                  className={classes.field}
                />
              </Grid>
              <Grid item xs={12}>
                <TextValidator
                  name="messageInSpanish"
                  label="Mensaje en Español *"
                  value={messageInSpanish}
                  onChange={this.handleChange}
                  validators={["required"]}
                  errorMessages={["El mensaje en español es requerido"]}
                  fullWidth
                  multiline
                  rows={3}
                  className={classes.field}
                />
              </Grid>
              <Grid item xs={12}>
                <TextValidator
                  name="messageInEnglish"
                  label="Mensaje en Inglés *"
                  value={messageInEnglish}
                  onChange={this.handleChange}
                  validators={["required"]}
                  errorMessages={["El mensaje en inglés es requerido"]}
                  fullWidth
                  multiline
                  rows={3}
                  className={classes.field}
                />
              </Grid>
              <Grid item xs={12} className={classes.checkboxGroup}>
                <Typography variant="subtitle1" gutterBottom>
                  Opciones de envío:
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={sendInApp}
                      onChange={this.handleChange}
                      name="sendInApp"
                      color="primary"
                    />
                  }
                  label="Enviar notificación in-app"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={sendPush}
                      onChange={this.handleChange}
                      name="sendPush"
                      color="primary"
                    />
                  }
                  label="Enviar push"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={sendEmail}
                      onChange={this.handleChange}
                      name="sendEmail"
                      color="primary"
                    />
                  }
                  label="Enviar mail"
                />
              </Grid>
            </Grid>
          </ValidatorForm>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            Cancelar
          </Button>
          <Button
            onClick={() => this.refs.form.submit()}
            color="primary"
            variant="contained"
            disabled={totalSelected === 0}
          >
            Enviar Notificaciones
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

NotificationModal.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  selectedUserIds: PropTypes.array,
  selectedConsumerIds: PropTypes.array,
};

export default withStyles(styles)(NotificationModal); 